export default function isLoggedIn({ next, nextMiddleware }) {
    //Если проверку не прошли то next('/');
    if (localStorage.getItem('accessToken') != null) {
        next({name: "MainPage"})
    }
    //Если ок, то nextMiddleware();
    return nextMiddleware();
}